(() => {
  const container = document.getElementById('SupplierFilter');
  if (!container || container.dataset.ready) return;
  container.dataset.ready = 'true';
  // 分類・醸造元それぞれの組（select + ボタン）を独立して動かす
  container.querySelectorAll('[data-supplier-select]').forEach((select) => {
    const group = select.closest('div') || container;
    const go = () => { if (select.value) window.location.assign(select.value); };
    group.querySelector('[data-supplier-go]')?.addEventListener('click', go);
    select.addEventListener('change', go);
  });
})();
